<template>
  <v-container>
    <v-row class="pt-3">
      <v-col order-md="8" align="center">
        <v-row class="justify-center">
          <v-btn
            medium
            color="primary"
            style="text-transform: none;"
            class="white--text"
            @click="reinitialiserCommande()"
          >Réinitialiser la commande</v-btn>

          <v-btn class="button ml-8" tile outlined color="primary" @click="clicUploadExcel()">
            <v-icon left>vertical_align_top</v-icon>Importer commande - fichier
            Excel
          </v-btn>
          <input id="excel" ref="excel" style="display: none;" type="file" @change="uploadExcel()" />
        </v-row>
      </v-col>
    </v-row>

    <!-- ------ ----->
    <!-- Demandeur -->
    <!-- ------ ----->
    <stepDemandeur />

    <!-- ------ ----->
    <!-- Destinataire -->
    <!-- ------ ----->
    <stepDestinataire />

    <!-- ------ ----->
    <!-- Commande -->
    <!-- ------ ----->
    <stepCommande />

    <!-- ------ ----->
    <!-- Confirmation -->
    <!-- ------ ----->
    <stepConfirmation />

    <v-row class="justify-center pt-6 pb-5">
      <v-btn class="button" tile outlined color="primary" @click="clicUploadExcel()">
        <v-icon left>vertical_align_top</v-icon>Importer commande - fichier
        Excel
      </v-btn>
      <input id="excel" ref="excel" style="display: none;" type="file" @change="uploadExcel()" />
    </v-row>
  </v-container>
</template>

<script>
import stepCommande from '@/components/commande/StepCommande.vue'
import stepConfirmation from '@/components/commande/StepConfirmation.vue'
import stepDemandeur from '@/components/commande/StepDemandeur.vue'
import stepDestinataire from '@/components/commande/StepDestinataire.vue'

export default {
  name: 'Commande',
  components: {
    stepDemandeur,
    stepDestinataire,
    stepCommande,
    stepConfirmation,
  },

  data() {
    return {
      commandeIPContexteData: {},
    }
  },

  computed: {
    agentConnecte: function () {
      return this.$store.getters.agentConnecte
    },
  },

  beforeMount() {
    // Lorsque la commande est copié
    if (this.$route.params.idCommande != null) {
      console.log('commande ' + this.$route.params.idCommande)

      axios
        .post('/commandesip/copiercommande', this.$route.params.idCommande)

        .then((response) => {
          let resp = response.data
          let msg = null
          this.$store.getters.commande.produits = []

          switch (resp.codeRetour) {
            case 'OK':
            case 'X001':
              this.commandeIPContexteData = resp.resultat

              this.$store.dispatch(
                'ajouterProduitLot',
                this.commandeIPContexteData.commandeIPData.produits
              )

              // La commande est "pour lui-même" seulement si le destinataire client est l'agent connecté
              this.$store.getters.commande.commandeAgent =
                this.commandeIPContexteData.commandeIPData.destinataireClient !=
                  null &&
                this.commandeIPContexteData.commandeIPData.destinataireClient
                  .noClientJDE === this.$store.getters.agentConnecte.noClientJDE

              if (this.$store.getters.commande.commandeAgent == true) {
                this.$store.getters.commande.destinataireClient =
                  this.commandeIPContexteData.commandeIPData
                    .destinataireClient ||
                  this.commandeIPContexteData.commandeIPData.destinataire ||
                  {}
              } else {
                this.$store.getters.commande.destinataireClient =
                  this.commandeIPContexteData.commandeIPData
                    .destinataireClient || {}
              }

              this.$store.getters.commande.noCommande =
                this.commandeIPContexteData.commandeIPData.noCommande
              this.$store.getters.commande.tsCommande = this.$fmtTsEnDate(
                this.commandeIPContexteData.commandeIPData.tsCommande
              )
              this.$store.getters.commande.nomContact =
                this.commandeIPContexteData.commandeIPData.nomContact
              this.$store.getters.commande.courrielContact =
                this.commandeIPContexteData.commandeIPData.courrielContact
              this.$store.getters.commande.commentaire =
                this.commandeIPContexteData.commandeIPData.commentaire
              this.$store.getters.commande.typeLivraison =
                this.commandeIPContexteData.commandeIPData.typeLivraison
              this.$store.getters.commande.succursaleLivraisonDemande =
                this.commandeIPContexteData.commandeIPData.succursaleLivraisonDemande
              this.$store.getters.commande.statutCommande =
                this.commandeIPContexteData.commandeIPData.statutCommande
              this.$store.getters.commande.dateEstimeeLivraison =
                this.commandeIPContexteData.commandeIPData.dateEstimeeLivraison
              this.$store.getters.commandeAgent == false
              break
            case 'V007':
              this.$store.dispatch(
                'afficherWarning',
                "La commande n'a pas pu être copiée car l'agent n'est pas existant"
              )
              break

            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch((error) => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    } else {
      this.$store.getters.commande.demandeur = this.$store.getters.agentConnecte
    }
  },

  methods: {
    afficherCreerCommande() {
      this.$store.dispatch('initialiserCommande')
      this.$router.push({ name: 'commande', params: { idCommande: null } })
    },

    validerIsAgentAutorisePourClient() {
      console.log('validerIsAgentAutorisePourClient')
      axios
        .get(
          `/agents/obtenirisagentautorise/${this.$store.getters.commande.demandeur.idDemandeur}/${this.$store.getters.commande.destinataireClient.idDemandeur}`
        )
        .then((response) => {
          const resp = response.data

          switch (resp.codeRetour) {
            case 'OK':
              // La commande est pour le client
              break
            case 'V014':
              this.$store.dispatch(
                'afficherWarning',
                `Vous n'avez pas l'autorisation d'effectuer une commande pour le compte de ce client. Veuillez communiquer avec ce dernier pour obtenir l'autorisation.`
              )

              this.$store.getters.commande.destinataireClient = {}

              break
            default:
              console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
              this.$store.dispatch(
                'afficherError',
                `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
              )
              break
          }
        })
        .catch((error) => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    reinitialiserCommande() {
      console.log('reinitialiserCommande')

      for (let i = 0; i < this.$store.getters.commande.produits.length; i++) {
        //this.$store.getters.commande.produits.splice(
        //  i,
        //  this.$store.getters.commande.produits.length
        //)

        this.$store.getters.commande.produits[
          i
        ].indMessageQuantiteCaisseAffiche = false
        this.$store.getters.commande.produits[
          i
        ].indQuantiteEtInventaireSousUVC = false
        this.$store.getters.commande.produits[i].indQuantiteInvalideUVC = false
        this.$store.getters.commande.produits[
          i
        ].indQuantiteRestanteModulo = false
      }

      this.$store.getters.commande.produits = []
      this.$store.getters.commande.demandeur = {}
      this.$store.getters.commande.destinataireClient = {
        instructionLivraisonData: {},
      }
      this.$store.getters.commande.dateEstimeeLivraison = null
      this.$store.getters.commande.demandeur.nomContact = null
      this.$store.getters.commande.demandeur.courrielContact = null
      this.$store.getters.commande.typeLivraison = null
      this.$store.getters.commande.journeeLivraison = null
      this.$store.getters.commande.commandeAgent = false
    },

    // ------------
    // Import excel
    // ------------
    clicUploadExcel() {
      this.$refs.excel.click()
    },

    async uploadExcel() {
      console.log('uploadExcel')
      let fichierExcel = this.$refs.excel.files[0]
      axios({
        url: `/commandesip/${this.agentConnecte.idDemandeur}/excelagent`,
        method: 'post',
        data: fichierExcel,
        headers: {
          'Content-Type': 'application/octet-stream',
        },
      })
        .then((response) => {
          let resp = response.data
          let msgs = ''
          let res = null
          this.$store.getters.commande.produits = []

          switch (resp.codeRetour) {
            case 'OK':
              this.$store.dispatch('initialiserCommande')

              this.commandeFichierExcel = resp.resultat

              this.$store.getters.commande.commandeExcel = true
              this.$store.getters.commande.destinataireClient =
                this.commandeFichierExcel.clientData
              this.$store.getters.commande.demandeur =
                this.$store.getters.agentConnecte
              this.$store.getters.commande.commentaire =
                this.commandeFichierExcel.commandeIPData.commentaire
              this.$store.getters.commande.demandeur.nomContact =
                this.commandeFichierExcel.commandeIPData.demandeur.nomContact
              this.$store.getters.commande.demandeur.courrielContact =
                this.commandeFichierExcel.commandeIPData.demandeur.courrielContact
              this.$store.getters.commande.nomContact =
                this.commandeFichierExcel.commandeIPData.nomContact
              this.$store.getters.commande.courrielContact =
                this.commandeFichierExcel.commandeIPData.courrielContact

              this.$store.getters.commande.tsCommande = this.$fmtTsEnDate(
                this.commandeFichierExcel.commandeIPData.tsCommande
              )

              this.$store.getters.commande.indPayeParAgent =
                this.commandeFichierExcel.commandeIPData.indPayeParAgent
              this.$store.getters.commande.typeLivraison =
                this.commandeFichierExcel.commandeIPData.typeLivraison
              this.$store.getters.commande.succursaleLivraisonDemande =
                this.commandeFichierExcel.commandeIPData.succursaleLivraisonDemande

              if (
                this.$store.getters.commande.destinataireClient.typeClient ==
                'TITULAIRE_POUR_REVENTE'
              ) {
                this.validerIsAgentAutorisePourClient()
              }

              if (
                this.$store.getters.commande.destinataireClient.typeClient ==
                  'PART_USAGE_PERSONNEL' ||
                this.$store.getters.commande.destinataireClient.typeClient ==
                  'LIEU_DE_CULTE'
              ) {
                this.$store.getters.commande.destinataireClient.nom =
                  this.$store.getters.commande.destinataireClient.nom
                this.$store.getters.commande.destinataireClient.nomContact =
                  this.$store.getters.commande.destinataireClient.nomContact
                this.$store.getters.commande.destinataireClient.courrielContact =
                  this.$store.getters.commande.destinataireClient.courrielContact
                this.$store.getters.commande.destinataireClient.adresse =
                  this.$store.getters.commande.destinataireClient.adresse
                this.$store.getters.commande.destinataireClient.ville =
                  this.$store.getters.commande.destinataireClient.ville
                this.$store.getters.commande.destinataireClient.codePostal =
                  this.$store.getters.commande.destinataireClient.codePostal
                this.$store.getters.commande.destinataireClient.noTelephone =
                  this.$store.getters.commande.destinataireClient.noTelephone
                this.$store.getters.commande.destinataireClient.posteTelephone =
                  this.$store.getters.commande.destinataireClient.posteTelephone
              }

              this.$store.dispatch(
                'ajouterProduitLot',
                this.commandeFichierExcel.commandeIPData.produits
              )
              this.$store.dispatch(
                'afficherSuccess',
                'Commande importée avec succès'
              )

              this.$refs.excel.value = null

              break

            case 'X001':
              this.$store.dispatch(
                'afficherError',
                "Un problème est survenu avec l'import du fichier Excel"
              )
              this.$refs.excel.value = null

              break
            case 'V198':
              // Erreurs de validation de l'Excel. "resultat" contient une liste de messages
              res = resp.resultat
              console.log(res)
              for (let i = 0; i < res.length; i++) {
                if (res[i].param) {
                  msgs += this.$t(res[i].cle, { p: res[i].param }) + '<br/>'
                } else {
                  msgs += this.$t(res[i].cle) + '<br/>'
                }
              }
              this.$store.dispatch('afficherWarning', msgs)
              this.$refs.excel.value = null

              break
            default:
              console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
              this.$store.dispatch(
                'afficherError',
                `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
              )
              break
          }
        })
        .catch((error) => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },
  },
}
</script>

<style scoped>
.button {
  height: 14px;
  width: 282px;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.43px;
  line-height: 16px;
  text-align: center;
  box-sizing: border-box;
  height: 14px;
  width: 338px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  background-color: rgba(98, 2, 238, 0);
}
</style>
